import { motion } from "framer-motion";
import { STEPS } from "./data";
import { Reveal, Overline } from "./primitives";
import { ElevationChart } from "./ElevationChart";

export const HowItWorks = () => {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="relative bg-white py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl">
          <Reveal>
            <Overline>The Workflow</Overline>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-heading text-4xl font-bold leading-[1.06] tracking-tight text-slate-900 sm:text-5xl">
              Six Steps to a Smarter Pipeline Design
            </h2>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-x-8 gap-y-10 md:grid-cols-2 lg:grid-cols-3">
          {STEPS.map((s, i) => (
            <Reveal key={s.no} delay={(i % 3) * 0.08}>
              <div className="group relative">
                <div className="flex items-center gap-4">
                  <span className="font-heading text-5xl font-black tracking-tighter text-slate-100 transition-colors duration-300 group-hover:text-[#1a6fc4]/15">
                    {s.no}
                  </span>
                  <div className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-[#1a6fc4]/8 text-[#1a6fc4] transition-all duration-300 group-hover:bg-[#1a6fc4] group-hover:text-white">
                    <s.icon className="h-5 w-5" strokeWidth={1.8} />
                  </div>
                </div>
                <h3 className="mt-4 font-heading text-xl font-bold tracking-tight text-slate-900">
                  {s.title}
                </h3>
                <p className="mt-2.5 text-[15px] leading-relaxed text-slate-600">
                  {s.desc}
                </p>
                <div className="mt-5 h-px w-full bg-slate-100">
                  <motion.div
                    initial={{ scaleX: 0 }}
                    whileInView={{ scaleX: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: 0.2 + (i % 3) * 0.08 }}
                    style={{ originX: 0 }}
                    className="h-px bg-gradient-to-r from-[#1a6fc4] to-[#5aa72f]"
                  />
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1} className="mt-16">
          <ElevationChart />
        </Reveal>
      </div>
    </section>
  );
};
